export enum CONTENT_INFOBAR_TYPE {
  error = 'error',
  warning = 'warning',
  success = 'success',
  info = 'info',
}
